module.exports = __webpack_public_path__ + "img/offline.7bd45457.png";